const navBarLabels = {
  "nav.bar.profile": "Profile",
  "nav.bar.switch-profile": "Switch profile",
  "nav.bar.settings": "Settings",
  "nav.bar.sign-out": "Sign out",
  "nav.bar.whats-new": "What's New",
};

export const navBar = {
  ...navBarLabels,
};
